<app-header></app-header>
<div class="py-5" style=" background:url(./media/small-industry.jpg) no-repeat; background-size: cover; height: auto;">
  <div class="container">
    <div style="margin: 0px auto; background: #fff; padding: 40px;border-radius: 20px; box-shadow: #45030a 0 0px 20px; position: relative;">
      <form [formGroup]="form">
        <!--(ngSubmit)="SavetoIaAPI(form)"-->
        <h2 class="text-center">Register As Implementing Agency</h2>
        <hr />
        <div class="container">
          <!-- Nav Tabs -->
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <a class="nav-link active" id="Step1-tab" data-bs-toggle="tab" href="#Step1" role="tab" aria-controls="Step1" aria-selected="true">Step 1</a>
            </li>
            <!--<li class="nav-item" role="presentation">
    <a class="nav-link" id="Step2-tab" data-bs-toggle="tab" href="#Step2" role="tab" aria-controls="Step2" aria-selected="false">Step 2</a>
  </li>-->
            <li class="nav-item" role="presentation">
              <a class="nav-link"
                 id="Step2-tab"
                 data-bs-toggle="tab"
                 href="#Step2"
                 role="tab"
                 aria-controls="Step2"
                 aria-selected="false"
                 (click)="goToStep2()"
                 [class.disabled]="!form.valid">Step 2</a>
            </li>
          </ul>

          <!-- Tab Content -->
          <div class="tab-content mt-4" id="myTabContent">
            <div class="tab-pane fade show active" id="Step1" role="tabpanel" aria-labelledby="Step1-tab">

              <div class="card mb-3">
                <div class="card-header"><h2>Name & Address</h2></div>
                <div class="card-body">
                  <div class="xyz ">

                    <div class="row mb-3">
                      <div class="col-md-6">
                        <label class="nowrap">Enter Name of Organization/Association<span class="text-danger">*</span></label>
                      </div>
                      <div class="col-md-6">
                        <input type="text" (keypress)="textAndSpaceOnly($event)" autocomplete="off" formControlName="NameOfOrganisation" trimValue id="txtOrgName" class="form-control"
                               name="NameOfOrganisation" placeholder="Name of Organization/Association" maxlength="100" /> <!--(keydown)="preventStartingSpace($event)"-->

                        <div *ngIf="f['NameOfOrganisation'].touched && f['NameOfOrganisation'].invalid">
                          <div *ngIf="f['NameOfOrganisation'].errors && f['NameOfOrganisation'].errors['required']" class="alert alert-danger required">
                            Organization Name is required
                          </div>
                          <div *ngIf="f['NameOfOrganisation'].errors && f['NameOfOrganisation'].errors['minlength']" class="alert alert-danger required">
                            Minimum length should be 3 and maximum should be 100 characters
                          </div>
                          <div *ngIf="f['NameOfOrganisation'].errors && f['NameOfOrganisation'].errors['maxlength']" class="alert alert-danger required">
                            Maximum should be 100 characters
                          </div>
                          <div *ngIf="f['NameOfOrganisation'].errors && f['NameOfOrganisation'].errors['pattern']" class="alert alert-danger required">
                            Name should not contain numbers and special characters
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <label class="nowrap">Enter Short Name of Organization/Association<span class="text-danger">*</span></label>
                      </div>
                      <div class="col-md-6">
                        <input type="text" (keypress)="textOnly($event)" autocomplete="off" formControlName="ShortNameOfOrganisation" id="shorttxtOrgName" class="form-control"
                               name="ShortNameOfOrganisation" placeholder="Short Name of Organization/Association" maxlength="10">
                        <div *ngIf="f['ShortNameOfOrganisation'].touched && f['ShortNameOfOrganisation'].invalid">
                          <div *ngIf="f['ShortNameOfOrganisation'].errors && f['ShortNameOfOrganisation'].errors['required']" class="alert alert-danger required">
                            Short Name of Organization is required
                          </div>
                          <div *ngIf="f['ShortNameOfOrganisation'].errors && f['ShortNameOfOrganisation'].errors['minlength']" class="alert alert-danger required">
                            Minimum length is 3 characters
                          </div>
                          <div *ngIf="f['ShortNameOfOrganisation'].errors && f['ShortNameOfOrganisation'].errors['maxlength']" class="alert alert-danger required">
                            Maximum length should be 10 characters
                          </div>

                          <div *ngIf="f['ShortNameOfOrganisation'].errors && f['ShortNameOfOrganisation'].errors['pattern']" class="alert alert-danger required">
                            Enter characters only
                          </div>
                        </div>
                      </div>
                      <!--<div class="col-6">-->
                      <!--<div class="center">
            <button id="btnsave">Save</button>
            <button id="btncancel" type="reset" (click)="onReset()">Cancel</button>
          </div>-->
                      <!--</div>-->
                      <!--<div class="col-6 vl">
            <div class="center"><img src="images/emb.png" /></div>
            <a href="#" class="center">I am already memebr</a>
          </div>-->
                    </div>



                    <div class="row mb-3">
                      <div class="col-md-6">
                        <label class="nowrap">Address<span class="text-danger">*</span></label>
                        <input type="text" autocomplete="off" formControlName="AddressOfOrganisation" trimValue id="address" class="form-control"
                               name="AddressOfOrganisation" placeholder="Address Of Organisation/Association" maxlength="300">
                        <div *ngIf="f['AddressOfOrganisation'].touched && f['AddressOfOrganisation'].invalid">
                          <div *ngIf="f['AddressOfOrganisation'].errors?.['required']" class="alert alert-danger">
                            Address is required.
                          </div>
                          <div *ngIf="f['AddressOfOrganisation'].errors?.['pattern']" class="alert alert-danger">
                            Address must not contain '&' character and should not start with "&#64;+-=".
                          </div>
                          <div *ngIf="f['AddressOfOrganisation'].errors?.['minlength']" class="alert alert-danger">
                            Address must be at least 3 characters long.
                          </div>
                          <div *ngIf="f['AddressOfOrganisation'].errors?.['maxlength']" class="alert alert-danger">
                            Address cannot exceed 300 characters.
                          </div>
                        </div>

                      </div>

                    </div>


                  </div>
                </div>
              </div>

              <div class="card mb-3">
                <div class="card-header"><h2>Email</h2></div>
                <div class="card-body">
                  <div class="xyz ">                  
                    <div class="row mb-3">
                      <div class="col-md-6">
                        <label class="nowrap">Email<span class="text-danger">*</span></label>
                        <input type="text" autocomplete="off" formControlName="Email" trimValue class="form-control" id="email"
                               name="Email" placeholder="Email" maxlength="100">
                        <div *ngIf="f['Email'].touched && f['Email'].invalid">
                          <div *ngIf="f['Email'].errors?.['required']" class="alert alert-danger required">
                            Email is required
                          </div>
                          <div *ngIf="f['Email'].errors?.['maxlength']" class="alert alert-danger required">
                            Maximum length should be 100 characters
                          </div>
                          <div *ngIf="f['Email'].errors?.['pattern']" class="alert alert-danger required">
                            Invalid email format
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <label class="nowrap">Password<span class="text-danger">*</span></label>
                        <div class="input-group">
                          <input [type]="showPassword ? 'text' : 'Password'" autocomplete="off" formControlName="Password"
                                 class="form-control" id="txtPassword" placeholder="Password" maxlength="20">
                          <div class="input-group-append">
                            <span class="input-group-text picon" (click)="toggleShowPassword()" style="cursor: pointer;">
                              <i class="fa" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                            </span>
                          </div>
                        </div>
                        <div *ngIf="f['Password'].touched && f['Password'].invalid">
                          <!-- Required Error -->
                          <div *ngIf="f['Password'].errors && f['Password'].errors['required']" class="alert alert-danger required">
                            Password is required. It must contain at least one lowercase letter, one uppercase letter, one numeric character, and one special character.
                          </div>

                          <!-- Min Length Error -->
                          <div *ngIf="f['Password'].errors && f['Password'].errors['minlength']" class="alert alert-danger required">
                            Minimum length should be 8 characters.
                          </div>

                          <!-- Max Length Error -->
                          <div *ngIf="f['Password'].errors && f['Password'].errors['maxlength']" class="alert alert-danger required">
                            Maximum length should be 20 characters.
                          </div>

                          <!-- Pattern Error -->
                          <div *ngIf="f['Password'].errors && f['Password'].errors['pattern']" class="alert alert-danger required">
                            Password must contain at least one lowercase letter, one uppercase letter, one numeric character, and one special character.
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <label class="nowrap">Confirm Password<span class="text-danger">*</span></label>
                        <div class="input-group">
                          <input [type]="showConfirmPassword ? 'text' : 'password'" autocomplete="off" formControlName="confpassword"
                                 class="form-control" id="txtConfirmpassword" placeholder="Retype-Password" maxlength="20" (paste)="onPaste($event)">
                          <div class="input-group-append">
                            <span class="input-group-text picon" (click)="toggleShowConfirmPassword()" style="cursor: pointer;">
                              <i class="fa" [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                            </span>
                          </div>
                        </div>
                        <div *ngIf="f['confpassword'].touched && f['confpassword'].invalid">
                          <div *ngIf="f['confpassword'].errors?.['required']" class="alert alert-danger required">
                            Enter Confirm Password
                          </div>
                          <div *ngIf="f['confpassword'].errors?.['minlength']" class="alert alert-danger required">
                            Minimum length should be 8 characters
                          </div>
                          <div *ngIf="f['confpassword'].errors?.['maxlength']" class="alert alert-danger required">
                            Maximum length should be 20 characters
                          </div>
                          <!-- Password Mismatch Error -->
                          <div *ngIf="f['confpassword'].errors?.['passwordMismatch']" class="alert alert-danger required">
                            Password and Confirm Password fields must match.
                          </div>



                        </div>


                      </div>
                      <div class="col-md-6">
                        <label class="nowrap"> Username<span class="text-danger">*</span></label>
                        <input type="text" class="form-control " id="username" formControlName="IAUserName" placeholder="Username"
                               [value]="emailControlValue" readonly>
                      </div>

                      <div class="col-md-6">
                        <input type="text" (keypress)="numberOnly($event)" autocomplete="off" id="txtEmailOTP" class="form-control" formControlName="emailotp"
                               placeholder="Enter OTP sent on your email" maxlength="6" [disabled]="isEmailOTPVerified">
                        <div *ngIf="f['emailotp'].touched && f['emailotp'].invalid">
                          <div *ngIf="f['emailotp'].errors && f['emailotp'].errors['required']" class="alert alert-danger required">
                            Enter otp sent to your email
                          </div>
                          <div *ngIf="f['emailotp'].errors && f['emailotp'].errors['minlength']" class="alert alert-danger required">
                            Minimum length should be 6
                          </div>
                          <div *ngIf="f['emailotp'].errors && f['emailotp'].errors['maxlength']" class="alert alert-danger required">
                            Maximum length should be 6
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <button id="btnsendemailotp" type="button" (click)="SendEmailOTP()" [disabled]="isButtonEmailDisabled || emailOtpTimerRunning" class="btn btn-primary mb-1">Send Email OTP</button>
                        <button id="btnresendemailotp" type="button" (click)="ReSendEmailOTP()" [disabled]="resendEmailOtpDisabled || emailOtpTimerRunning" class="btn btn-primary mb-1">
                          Resend Email OTP

                          <span *ngIf="emailOtpTimerRunning"> {{emailOtpTimer}}<!--({{ countdownDisplay }})--></span>

                        </button>
                        
                        <button id="btnverifyotp" type="button" (click)="verifyEmailOtp()" class="btn btn-success" [disabled]="isVerifyEmailOtpButtonDisabled">Verify Email OTP</button>
                      </div>
                      <div class="col-md-6">

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card mb-3">
                <div class="card-header"><h2>Mobile Number</h2></div>
                <div class="card-body">
                  <div class="xyz">
                  
                    <!--<div class="progress">-->
                    <!--<div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
         style="width:20%; background-color: red;">
    </div>-->
                    <!--</div>-->
                    <div class="row mb-3">
                      <div class="col-md-4">
                        <label class="nowrap">Mobile Number<span class="text-danger">*</span></label>
                        <input type="text" (keypress)="numberOnly($event)" autocomplete="off" id="txtMobNum" class="form-control" formControlName="MobileNumber"
                               placeholder="Enter Mobile Number" maxlength="10">
                        <div *ngIf="f['MobileNumber'].touched && f['MobileNumber'].invalid">
                          <div *ngIf="f['MobileNumber'].errors && f['MobileNumber'].errors['required']" class="alert alert-danger required">
                            Mobile number is required
                          </div>
                          <div *ngIf="f['MobileNumber'].errors && f['MobileNumber'].errors['pattern']" class="alert alert-danger required">
                            Invalid mobile number format
                          </div>
                        </div>
                        
                      </div>
                      <div class="col-md-8" style="margin-top: 25px;">
                        <button id="btnsendotp" type="button" (click)="SendOTP()" [disabled]="isButtonMobileDisabled || mobileOtpTimerRunning" class="btn btn-primary mb-1">Send Mobile OTP</button>
                        <button id="btnresendotp" type="button" (click)="ReSendMobileOTP()" [disabled]="resendMobileOtpDisabled || mobileOtpTimerRunning" class="btn btn-primary mb-1">
                          Resend Mobile OTP
                          <span *ngIf="mobileOtpTimerRunning"> {{mobileOtpTimer}}<!--({{ countdownDisplay }})--></span>
                        </button>

                      </div>
                      <div class="col-md-6">

                        <input type="text" (keypress)="numberOnly($event)" autocomplete="off" id="txtMobOTP" class="form-control" formControlName="mobotp"
                               placeholder="Enter OTP sent on your mobile number" maxlength="6" [disabled]="isMobOTPVerified">
                        <div *ngIf="f['mobotp'].touched && f['mobotp'].invalid">
                          <div *ngIf="f['mobotp'].errors && f['mobotp'].errors['required']" class="alert alert-danger required">
                            Enter otp sent to your mobile
                          </div>
                          <div *ngIf="f['mobotp'].errors && f['mobotp'].errors['minlength']" class="alert alert-danger required">
                            Minimum length should be 6
                          </div>
                          <div *ngIf="f['mobotp'].errors && f['mobotp'].errors['maxlength']" class="alert alert-danger required">
                            Maximum length should be 6
                          </div>
                        </div>

                      </div>

                      <div class="col-md-6">

                        <button id="btnmobverifyotp" type="button" (click)="verifyMobileOtp()" [disabled]="isVerifyMobileOtpButtonDisabled" class="btn btn-success">Verify Mobile OTP</button>


                      </div>

                    </div>
                  </div>
                </div>
              </div>
            
             
              <div class="mt-3 text-center">
                <button class="btn btn-success" id="nextBtn" (click)="goToStep2()">Save</button>
                <button id="btncancel" type="reset" (click)="onReset()" class="btn btn-danger">Reset</button>
                <button class="btn btn-danger" id="btnBack" type="submit" [routerLink]="'/login'">Cancel</button>
                <!--<button class="btn btn-success" id="ResetBtn" (click)="goToStep2()">Save</button>-->

              </div>
            </div>
            <div class="tab-pane fade" id="Step2" role="tabpanel" aria-labelledby="Step2-tab">
              <div class="xyz ">



                <div class="mb-3">

                  
                  <!--</div>-->
                  <div class="card mb-3">
                    <div class="card-header"><h2>SPOC Details</h2></div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-3">
                          <label class="nowrap">Contact Number (Landline Number)</label>
                          <input type="text"
                                 autocomplete="off"
                                 id="txtContactNumber"
                                 class="form-control"
                                 formControlName="ContactNumber"
                                 placeholder="Enter Contact Number"
                                 
                                 (input)="formatContactNumber($event)"
                                 (keypress)="numberOnly($event)" maxlength="13">
                          <div *ngIf="f['ContactNumber'].touched && f['ContactNumber'].invalid">
                            
                            <div *ngIf="f['ContactNumber'].errors?.['pattern']" class="alert alert-danger">
                              Please enter a valid contact number in the format XXX-XXXX-XXXX.
                            </div>
                            
                          </div>
                        </div>
                      </div>
                      <div class="row mb-2">
                        <div class="col-md-3">
                          <label class="nowrap">Spoc Name<span class="text-danger">*</span></label>
                          <input type="text" (keypress)="textAndSpaceOnly($event)" autocomplete="off" id="txtSpocName" class="form-control"
                                 formControlName="SpocName" trimValue placeholder="Enter Spoc Name" maxlength="50">
                          <div *ngIf="f['SpocName'].touched && f['SpocName'].invalid">
                            <div *ngIf="f['SpocName'].errors && f['SpocName'].errors['required']" class="alert alert-danger required">
                              Spoc Name is requried
                            </div>
                            <div *ngIf="f['SpocName'].errors && f['SpocName'].errors['minlength']" class="alert alert-danger required">
                              Minimum length should be 3 characters
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <label class="nowrap">Spoc Designation<span class="text-danger">*</span></label>
                          <input type="text" (keypress)="textAndSpaceAndDotOnly($event)" autocomplete="off" id="txtSpocDesignation" class="form-control"
                                 formControlName="SpocDesignation" trimValue placeholder="Enter Spoc Designation" maxlength="50">
                          <div *ngIf="f['SpocDesignation'].touched && f['SpocDesignation'].invalid">
                            <div *ngIf="f['SpocDesignation'].errors && f['SpocDesignation'].errors['required']" class="alert alert-danger required">
                              Spoc Designation is requried
                            </div>
                            <div *ngIf="f['SpocName'].errors && f['SpocName'].errors['minlength']" class="alert alert-danger required">
                              Minimum length should be 3 characters
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <label class="nowrap">Spoc Email<span class="text-danger">*</span></label>
                          <input type="text" autocomplete="off" id="txtSpocEmail" class="form-control"
                                 formControlName="SpocEmail" trimValue placeholder="Enter Spoc Email" maxlength="100">
                          <div *ngIf="f['SpocEmail'].touched && f['SpocEmail'].invalid">
                            <div *ngIf="f['SpocEmail'].errors && f['SpocEmail'].errors['required']" class="alert alert-danger required">
                              Spoc Email is requried
                            </div>
                            <div *ngIf="f['SpocEmail'].errors && f['SpocEmail'].errors['minlength']" class="alert alert-danger required">
                              Minimum length should be 3 characters
                            </div>
                            <div *ngIf="f['SpocEmail'].errors?.['pattern']" class="alert alert-danger required">
                              Invalid email format
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <label class="nowrap">Spoc Mobile<span class="text-danger">*</span></label>
                          <input type="text" (keypress)="numberOnly($event)" autocomplete="off" id="txtSpocMobile" class="form-control"
                                 formControlName="SpocMobile" placeholder="Enter Spoc Mobile" maxlength="10">
                          <div *ngIf="f['SpocMobile'].touched && f['SpocMobile'].invalid">
                            <div *ngIf="f['SpocMobile'].errors && f['SpocMobile'].errors['required']" class="alert alert-danger required">
                              Spoc Mobile is requried
                            </div>
                            <div *ngIf="f['SpocMobile'].errors && f['SpocMobile'].errors['pattern']" class="alert alert-danger required">
                              Invalid mobile number format
                            </div>
                          </div>

                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-3">

                          <!--<button id="btnsendotp" type="button" (click)="SendSpocOTP()" [disabled]="isButtonSpocMobileDisabled || mobileSpocOtpTimerRunning" class="btn btn-primary mb-1">Send Mobile OTP</button>-->
                          <button id="btnsendotp" type="button" (click)="SendSpocOTP()" [disabled]="(isButtonSpocMobileDisabled || mobileSpocOtpTimerRunning) ||  !(f['SpocMobile'].value?.length === 10) " class="btn btn-primary mb-1 me-2">Send Mobile OTP</button>
                          <button id="btnresendotp" type="button" (click)="ReSendSpocMobileOTP()" [disabled]="resendSpocMobileOtpDisabled || mobileSpocOtpTimerRunning" class="btn btn-primary mb-1">
                            Resend Mobile OTP
                            <span *ngIf="mobileSpocOtpTimerRunning"> {{mobileSpocOtpTimer}}<!--({{ countdownDisplay }})--></span>
                            
                          </button>

                        </div>
                        <div class="col-md-3">


                          <input type="text" (keypress)="numberOnly($event)" autocomplete="off" id="txtMobOTP" class="form-control" formControlName="spocmobotp"
                                 placeholder="Enter OTP sent on your mobile number" maxlength="6" [disabled]="isSpocOTPVerified">
                          <div *ngIf="f['spocmobotp'].touched && f['spocmobotp'].invalid">
                            <!--<div *ngIf="f['spocmobotp'].errors && f['spocmobotp'].errors['required']" class="alert alert-danger required">
              Enter otp sent to your mobile
            </div>-->
                            <div *ngIf="f['spocmobotp'].errors && f['spocmobotp'].errors['minlength']" class="alert alert-danger required">
                              Minimum length should be 6
                            </div>
                            <div *ngIf="f['spocmobotp'].errors && f['spocmobotp'].errors['maxlength']" class="alert alert-danger required">
                              Maximum length should be 6
                            </div>
                          </div>

                        </div>
                        <div class="col-md-3">
                          <button id="btnverifyotp" type="button" (click)="verifySpocMobileOtp()" [disabled]="(isVerifySpocMobileOtpButtonDisabled) || !(f['spocmobotp'].value?.length === 6)" class="btn btn-success mb-1">Verify Mobile OTP</button>
                        </div>



                        <div class="col-md-3">

                          <button *ngIf="editingIndex !== null" class="btn btn-primary" (click)="add()">Update</button>
                          <button *ngIf="editingIndex === null" class="btn btn-primary" (click)="add()">Add</button>
                          <button class="btn btn-danger" (click)="resetSpocSelection()">{{txtResetCancel}}</button>


                        </div>
                      </div>
                      <div class="mt-4">
                        <div *ngIf="spocList.length === 0" style="color: red;">
                          At least one SPOC must be added.(Fill in the Spoc deatils and verify the OTP to add)
                        </div>
                        <!--<h4>SPOC Details</h4>-->
                        <div class="table-responsive ">
                          <table class="table table-striped table-bordered table-hover">
                            <thead>
                              <tr>
                                <th>Sr. No.</th>
                                <th>Spoc Name</th>
                                <th>Spoc Designation</th>
                                <th>Spoc Email</th>
                                <th>Spoc Mobile</th>
                                <th>Action</th>

                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let record of spocList;let i = index">
                                <td>{{ i + 1 }}</td>
                                <td>{{ record.SpocName }}</td>
                                <td>{{ record.SpocDesignation }}</td>
                                <td>{{ record.SpocEmail }}</td>
                                <td>{{ record.SpocMobile }}</td>
                                <td>

                                  <button *ngIf="!record.isEdited" (click)="editSpoc(i)" class="btn btn-primary btn-sm"><i class="bi bi-pencil"></i> Edit </button>


                                  <button (click)="removeSpoc(i)" class="btn btn-danger btn-sm"><i class="bi bi-trash"></i> Remove</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>
                        </div>

                      </div>



                    </div>
                  </div>

                  <div class="card mb-3">
                    <div class="card-header"><h2>RAMP</h2></div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-4">
                          <label class="nowrap">Intervention<span class="text-danger">*</span></label>
                          <!--<select id="txtIntervention" class="form-control" formControlName="Intervention" (change)="onInterventionChange($event)">
    <option value="" disabled selected>Select Intervention</option>
    <option *ngFor="let type of interventions" [value]="type.interventionId">
      {{ type.interventionName }}
    </option>
  </select>-->

                          <ng-select [items]="interventions"
                                     bindLabel="interventionName"
                                     bindValue="interventionId"
                                     formControlName="Intervention"
                                     [searchable]="true"
                                     placeholder="--select--"
                                     (change)="onInterventionChange($event)" appendTo="body">
                          </ng-select>

                          <div *ngIf="f['Intervention'].touched && f['Intervention'].invalid" class="alert alert-danger">
                            <div *ngIf="f['Intervention'].errors && f['Intervention'].errors['required']">
                              Select at least 1 intervention
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <label class="nowrap">Components<span class="text-danger">*</span></label>
                          <!--<select id="txtInterests" class="form-control" formControlName="InterestsId">
    <option value="" disabled selected>Select Component</option>
    <option *ngFor="let type of filteredInterests" [value]="type.interestId">
      {{ type.interestName }}
    </option>
  </select>-->

                          <ng-select [items]="filteredInterests"
                                     bindLabel="interestName"
                                     bindValue="interestId"
                                     formControlName="InterestsId"
                                     [searchable]="true"
                                     placeholder="--select--"
                                     appendTo="body">
                          </ng-select>


                          <div *ngIf="f['InterestsId'].touched && f['InterestsId'].invalid" class="alert alert-danger">
                            <div *ngIf="f['InterestsId'].errors && f['InterestsId'].errors['required']">
                              Select at least 1 interest
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4" style="margin-top:22px;">
                          <button class="btn btn-primary" (click)="addPair()">Add Pair</button>
                        </div>
                      </div>

                      <div>
                        <div *ngIf="selectedPairs.length === 0" style="color: red;">

                          At least one pair must be added.
                        </div>
                        <div class="table-responsive ">
                          <table class="table table-striped table-bordered table-hover">
                            <thead>
                              <tr>
                                <th>Sr. No.</th>
                                <th>Intervention</th>
                                <th>Component</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let pair of selectedPairs; let i = index">
                                <td>{{ i + 1 }}</td>
                                <td>{{ pair.interventionName }}</td>
                                <td>{{ pair.interestName }}</td>
                                <td>
                                  <button (click)="removePair(i)" class="btn btn-danger btn-sm"><i class="bi bi-trash"></i> Remove</button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div class="col-md-12">
                        <div class="alert alert-success">
                          <label class="nowrap">Focus Sector (You can choose multiple options)<span class="text-danger">*</span></label>
                        </div>
                      </div>
                      <div *ngIf="focusSector.length > 0">
                        <div *ngFor="let focussector of focusSector">
                          <label>
                            <input type="checkbox"
                                   [value]="focussector.focusSectorid"
                                   [name]="focussector.focusSectorName"
                                   (change)="onFocusSectorChange($event, focussector.focusSectorId, focussector.focusSectorName)" />
                            {{ focussector.focusSectorName}}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
           
              <div class="text-center">
                <button id="btncancel" type="reset" (click)="onReset()" class="btn btn-danger">Reset</button>

                <button id="btnsave" type="button" (click)="SendtoPreview(form)" class="btn btn-success">Preview</button>

                <button class="btn btn-danger" id="btnBack" type="submit" [routerLink]="'/login'">Cancel</button>
              </div>

            </div>
          </div>

        </div>



      </form>
    </div>
  </div>

</div>




<app-footer></app-footer>
